/**
 * 生成导出文件名称
 * name+年月日
 */
export function nameGeneration(filename) {
  const now = new Date()
  const year = now.getFullYear()
  const month = (now.getMonth() + 1).toString().padStart(2, '0')
  const day = now.getDate().toString().padStart(2, '0')

  return `${filename || '未命名'}_${year}${month}${day}`
}

export function hasOwnProperty(origin, prop) {
  return Object.prototype.hasOwnProperty.call(origin, prop)
}

/**
 * JSON.parse 兼容非 JSON 字符串形式
 * @param {*} value
 */
export function parseJson(value) {
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

// 级联云 CCC 语音转换
export function transAudio(value) {
  if (window.CCCWebApi) {
    const { RecordApi } = window.CCCWebApi
    if (value) {
      return RecordApi.fetchAndDecodeData(decodeURIComponent(value))
    }
  } else {
    return value
  }
}

/**
 * 数字格式化,如果非数字或NaN,Infinity,-Infinity将返回undefined
 * @param {Number} value 数字
 * @param {Integer} digits 小数位,自动四舍五入
 * @param {String} type 类型 percent | number
 * @returns {String}
 */
export function formatterNumber(value, digits = 0, type = 'number', unNeedFixed) {
  if ([null, undefined, '', false, "'null'", 'null'].includes(value)) {
    return undefined
  }
  const number = Number(value)
  if ([NaN, 'NaN', Infinity, -Infinity].includes(number)) {
    return undefined
  }
  if (type === 'percent') {
    const percentValue = (number * 10000) / 100
    return unNeedFixed ? percentValue.toFixed(2) : (number * 100).toFixed(digits)
  }
  return number.toFixed(digits)
}

/**
 * 数字格式化,如果非数字或NaN,Infinity,-Infinity将返回 --
 * 百分数自动加上百分号
 * @param {Number} value 数字
 * @param {Integer} digits 小数位,自动四舍五入
 * @param {String} type 类型 percent | number
 * @returns {String}
 */
export function formatNumber(value, digits = 0, type = 'number', needSubstring = false, substringIndex = 4) {
  if ([null, undefined, '', false].includes(value)) {
    return '--'
  }
  const number = Number(value)
  if ([NaN, Infinity, -Infinity].includes(number)) {
    return '--'
  }
  if (type === 'percent') {
    return needSubstring ? (number * 100 + '').substring(0, substringIndex) + '%' : (number * 100).toFixed(digits) + '%'
  }
  return needSubstring ? ((number + '').substring(0, substringIndex) - 0).toFixed(digits) : number.toFixed(digits)
}

/**
 * 分数格式化，如果非数字或NaN、''将返回 '--'
 * @param {Number} num 数字
 * @param {Integer} decimalPlaces 小数位，不四舍五入，正常应该小于4位
 * @returns {String}
 */
export function formatScore(num, decimalPlaces = 2) {
  if (isNaN(num) || num === '') {
    return '--'
  }

  const integerPart = Math.floor(num).toString()
  let decimalString = ''

  if (decimalPlaces > 0) {
    const decimal = (Math.round(num * 10000) - Math.floor(num) * 10000) / 10000
    decimalString = decimal === 0 ? '00' : (decimal + '000').substring(2, decimalPlaces + 2)
  }

  return decimalString ? `${integerPart}.${decimalString}` : integerPart
}

export function transValueToNumber(value) {
  value = value.trim()
  if (value === null || value === undefined || value === '') return ''
  value = String(value)
  value = value.replace(/[^\d.-]/g, '')
  // 保证只有 1 个负号，且只能在开头
  const minusCount = (value.match(/-/g) || []).length
  if (minusCount > 1) {
    value = value.substring(0, value.lastIndexOf('-'))
  }
  if (value.indexOf('-') > 0) {
    value = value.replace(/-/g, '')
  }
  // 确保只有一个小数点
  const dotCount = (value.match(/\./g) || []).length
  if (dotCount > 1) {
    value = value.substring(0, value.lastIndexOf('.'))
  }
  if (value.indexOf('.') === 0) {
    value = '0' + value
  }

  return value
}
/**
 * html解码 &amp; &lt; &gt;
 * @param {String} html 需要解码的字符串
 * @returns 解码后的字符串
 */
export function HTMLDecode(text) {
  var temp = document.createElement('div')
  temp.innerHTML = text
  var output = temp.innerText || temp.textContent
  temp = null
  return output
}

/**
 * html编码 & < >
 * @param {String} html 需要编码的字符串
 * @returns 编码后的字符串
 */
export function HTMLEncode(html) {
  var temp = document.createElement('div')
  temp.textContent != null ? (temp.textContent = html) : (temp.innerText = html)
  var output = temp.innerHTML
  temp = null
  return output
}

/**
 * 创建下载
 * @param {URL} url
 * @param {String} fileName
 */
export function createDownload(url, fileName) {
  let a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', fileName)
  document.body.appendChild(a)
  a.click()
  // document.removeChild(a)
}

export const textWrap = ({ text = '', chLength = 10, enLength = 15 }) => {
  const isChinese = /[\u4e00-\u9fa5]/.test(text)
  if (isChinese) {
    // 中文按字符分割，每行最多5个字符
    return text.match(new RegExp(`.{1,${chLength}}`, 'g')).join('\n')
  } else {
    // 英文按字符长度换行，每行最多15个字符且不打破单词
    const words = text.split(/([\s,./]+)/)
    const result = []
    let currentLine = ''

    words.forEach(word => {
      if (word.trim() === '') return
      if (currentLine.length + word.length + 1 > enLength) {
        result.push(currentLine)
        currentLine = word
      } else {
        currentLine = currentLine ? `${currentLine} ${word}` : word
      }
    })

    if (currentLine) result.push(currentLine)
    return result.join('\n')
  }
}
